import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './style.module.scss';

const Loader = (props) =>
    <div className={cx({
        [styles.loader]: true,
        [styles.small]: props.size === "sm",
        [styles.medium]: props.size === "md",
        [styles.large]: props.size === "lg",
        [styles.secondary]: props.secondary
    })} />

Loader.propTypes = {
    size: PropTypes.oneOf(["sm", "md", "lg"]),
    secondary: PropTypes.bool
}

export default Loader;